var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "key",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.99,
    height: 21,
    viewBox: "0 0 20.99 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M15.75,1.5A6.75,6.75,0,0,0,9.1,9.406a1.024,1.024,0,0,1-.221.906l-6.5,6.5A3,3,0,0,0,1.5,18.932V21.75a.75.75,0,0,0,.75.75H6a.75.75,0,0,0,.75-.75v-1.5h1.5A.75.75,0,0,0,9,19.5V18h1.5a.75.75,0,0,0,.53-.22l2.658-2.658a1.022,1.022,0,0,1,.906-.22A6.75,6.75,0,1,0,15.75,1.5Zm0,3a.75.75,0,0,0,0,1.5A2.25,2.25,0,0,1,18,8.25a.75.75,0,0,0,1.5,0A3.75,3.75,0,0,0,15.75,4.5Z",
    transform: "translate(-1.5 -1.5)",
    fill: "#18181a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.c096f761b83190e428a944f36233093a.svg";
export { ForwardRef as ReactComponent };